/**
 * Reconciliation method for reconciliation settings XHRs
 * @private
 */
export enum ReconciliationMethod {
  AutomaticReconciliation = 'AutomaticReconciliation',
  ManualReconciliation = 'ManualReconciliation',
}

/**
 * Response model for reconciliation settings XHRs
 */
export interface ReconciliationSettingsResponseModel {
  reconciliationMethod: ReconciliationMethod;
  skipBills: boolean;
  skipInvoices: boolean;
  /** QuickBooks Desktop Only **/
  skipContactsSync?: boolean;
  /** QuickBooks Desktop Only **/
  includeCustomerName?: boolean;
}

/**
 * Request model for reconciliation settings XHRs
 */
export type ReconciliationSettingsRequestModel = Partial<ReconciliationSettingsResponseModel>;
